{
  "collapse": "Згорнути",
  "expand": "Розгорнути"
}
